import { createRequestTypes } from '@shopee/redux-commons';

export const FETCH_CART_DRAWER_ITEMS = createRequestTypes(
  'FETCH_CART_DRAWER_ITEMS'
);
